/*
 * <copyright company="Argenbright Innovations Lab">
 *        copyright (c) Argenbright Innovations Lab, an Argenbright Holdings Company.  All rights reserved.
 * </copyright>
 */

import { PdfThumbnailContainer, PdfThumbnailEmbed } from './TaskDetailsPage.Style';

const PdfThumbnail = ({ url, onClick }: { url: string; onClick?: () => void }) => {
  return (
    <PdfThumbnailContainer onClick={onClick}>
      <PdfThumbnailEmbed src={`${url}#page=1&view=FitH`} title="pdf-thumbnail" />
    </PdfThumbnailContainer>
  );
};

export default PdfThumbnail;
